import topAnimesBanner from 'assets/top-anime.jpg';

const images = {
  topAnimesBanner,
};

export default images;
